export default function PageHeader({ title, subtitle, children, owner }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        <h1 className={`font-heading text-2xl sm:text-3xl font-semibold tracking-tight ${owner ? "text-navy" : "text-slate-900"}`}>
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1.5">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
